import {
  DndContext,
  type DragEndEvent as DndKitDragEndEvent,
  type DragOverEvent as DndKitDragOverEvent,
  type DragStartEvent as DndKitDragStartEvent,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core"
import React from "react"

interface DragDropProviderProps {
  children: React.ReactNode
  onDragStart?: (event: DndKitDragStartEvent) => void
  onDragOver?: (event: DndKitDragOverEvent) => void
  onDragEnd?: (event: DndKitDragEndEvent) => void
}

export const DragDropProvider: React.FC<DragDropProviderProps> = ({
  children,
  onDragStart,
  onDragOver,
  onDragEnd,
}) => {
  const mouseSensor = useSensor(MouseSensor, {
    activationConstraint: {
      distance: 8,
    },
  })
  const touchSensor = useSensor(TouchSensor, {
    activationConstraint: {
      delay: 200,
      tolerance: 5,
    },
  })

  const sensors = useSensors(mouseSensor, touchSensor)

  return (
    <DndContext
      sensors={sensors}
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDragEnd={onDragEnd}
    >
      {children}
    </DndContext>
  )
}
